"use client";

import { useEffect, useRef } from "react";

/**
 * İçerik viewport'a girdiğinde (görünür olduğunda) dataLayer'a event(ler) push eder.
 * Intersection Observer ile nesne görünür olduğunda bir kez tetiklenir.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Sarılacak içerik
 * @param {Object|Object[]} props.events - dataLayer'a push edilecek event objesi veya event objeleri dizisi
 */
export default function ViewEventTracker({ children, events }) {
  const containerRef = useRef(null);
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (events == null || hasFiredRef.current) return;

    const eventsList = Array.isArray(events) ? events : [events];
    if (eventsList.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (!entry?.isIntersecting || hasFiredRef.current) return;

        hasFiredRef.current = true;

        if (typeof window === "undefined") return;
        window.dataLayer = window.dataLayer || [];

        let needEcommerceClear = false;
        for (const evt of eventsList) {
          if (evt?.ecommerce) {
            needEcommerceClear = true;
            break;
          }
        }

        if (needEcommerceClear) {
          window.dataLayer.push({ ecommerce: null });
        }

        eventsList.forEach((evt) => {
          if (evt && typeof evt === "object") {
            window.dataLayer.push({ ...evt });
          }
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -50px 0px" }
    );

    const el = containerRef.current;
    if (el) observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
    };
  }, [events]);

  return <div ref={containerRef}>{children}</div>;
}
